import * as yup from "yup";
import { Spinner } from "../components/spinner";
import { Formik, FormikProps, Form, Field, ErrorMessage } from "formik";
import { FormikErrorMessage } from "../components/formik-error-message";
import { WebLayout } from "../components/web-layout";
import React from "react";

export interface Props {
    match?: any;
    onSubmit: (
        email: string,
        password: string,
        solera?: any,
        eligibility_id?: string
    ) => any;
}

interface State {
    emailDisabled: boolean;
    email: string;
    password: string;
    confirm_password: string;
    solera?: any;
    eligibility_id?: string;
}

export class SignUpPage extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);

        let email = "",
            emailDisabled = false,
            solera = undefined,
            eligibility_id = undefined;
        if (this.props.match && this.props.match.params.data) {
            const json = JSON.parse(atob(this.props.match.params.data));
            email = json.Email;
            emailDisabled = email ? true : false;
            solera = this.props.match.params.data;
            eligibility_id = json.eligibility_id;
        }

        this.state = {
            email,
            password: "",
            confirm_password: "",
            emailDisabled,
            solera,
            eligibility_id,
        };
    }

    render() {
        const schema = yup.object().shape({
            email: yup.string().email().required("is required"),
            password: yup
                .string()
                .min(8, "has to be equal or longer than 8 characters!")
                .required("is required"),
            confirm_password: yup
                .string()
                .test(
                    "match",
                    "password do not match",
                    function (confirm_password) {
                        return confirm_password == this.parent.password;
                    }
                )
                .required("is required"),
        });
        return (
            <WebLayout>
                <Formik
                    initialValues={this.state}
                    onSubmit={this.onSubmit}
                    validationSchema={schema}
                    render={(formikProps: FormikProps<State>) => (
                        <Form
                            placeholder={undefined}
                            onPointerEnterCapture={undefined}
                            onPointerLeaveCapture={undefined}
                        >
                            <div className="pb-4">
                                <Field
                                    type="email"
                                    name="email"
                                    placeholder="Email"
                                    className="form-control"
                                    disabled={
                                        formikProps.initialValues.emailDisabled
                                    }
                                />
                                <ErrorMessage
                                    name="email"
                                    component={FormikErrorMessage}
                                />
                            </div>
                            <div className="pb-4">
                                <Field
                                    type="password"
                                    name="password"
                                    placeholder="Password"
                                    className="form-control"
                                />
                                <i className="text-xs">
                                    Must contain a letter, a number and a
                                    symbol. It must be at least 8 characters
                                    long.
                                </i>
                                <ErrorMessage
                                    name="password"
                                    component={FormikErrorMessage}
                                />
                            </div>
                            <div className="pb-4">
                                <Field
                                    type="password"
                                    name="confirm_password"
                                    placeholder="Retype Password"
                                    className="form-control"
                                />
                                <ErrorMessage
                                    name="confirm_password"
                                    component={FormikErrorMessage}
                                />
                            </div>
                            <button
                                type="submit"
                                className="btn btn-success form-control"
                                disabled={formikProps.isSubmitting}
                            >
                                {" "}
                                {formikProps.isSubmitting && <Spinner />}{" "}
                                REGISTER NOW!
                            </button>
                        </Form>
                    )}
                />
            </WebLayout>
        );
    }

    onSubmit = async (values: State, actions: any) => {
        try {
            await this.props.onSubmit(
                values.email,
                values.password,
                this.state.solera,
                this.state.eligibility_id
            );
            actions.setSubmitting(false);
            //actions.resetForm();
        } catch (error: any) {
            actions.setSubmitting(false);
            if (error.data && error.data.errors) {
                actions.setErrors(error.data.errors);
            } else {
                alert(error.message);
            }
        }
    };
}
